import { GeometryType } from "@evergis/api";
import { IconTypesKeys } from "@evergis/ui";

export const getObjectIcon = (type?: GeometryType): IconTypesKeys => {
  switch (type) {
    case GeometryType.Unknown:
      return "geom_types";
    case GeometryType.Point:
      return "geom_point";
    case GeometryType.Polyline:
      return "geom_polyline";
    case GeometryType.Polygon:
      return "geom_polygon";
    case GeometryType.Multipoint:
      return "editgeom_point_addpart";
    default:
      return null;
  }
};
